import { inject, Injectable } from '@angular/core';
import { Site } from '@simlab/navvis/auth';
import { NavvisHttpClientBypass } from '../lib/navvis-api-configuration';

@Injectable()
export class NavvisApiService {
  private readonly _httpClient = inject(NavvisHttpClientBypass);

  sities(instanceUrl: string) {
    return this._httpClient.get<Site[]>(`${instanceUrl}/api/sites`);
  }
}
